const AUTH_STORAGE_KEY = 'cpaws-dashboard-auth'
const VALID_PASSWORD = import.meta.env.VITE_DASHBOARD_PASSWORD || 'cpaws2026'

export interface AuthState {
  isAuthenticated: boolean
  loginAttempted: boolean
}

/**
 * Check if user is currently authenticated.
 */
export function isAuthenticated(): boolean {
  return localStorage.getItem(AUTH_STORAGE_KEY) === 'true'
}

/**
 * Attempt login with password.
 * Returns true if password is correct.
 */
export function login(password: string): boolean {
  if (password === VALID_PASSWORD) {
    localStorage.setItem(AUTH_STORAGE_KEY, 'true')
    return true
  }
  return false
}

/**
 * Log out current user.
 */
export function logout(): void {
  localStorage.removeItem(AUTH_STORAGE_KEY)
}

/**
 * Get current auth state.
 */
export function getAuthState(): AuthState {
  return {
    isAuthenticated: isAuthenticated(),
    loginAttempted: false,
  }
}
